import { z } from "zod"

export const optionSchema = z.object({
  label: z.custom<string | JSX.Element>(),
  value: z.string()
}, { message: 'Campo obrigatório' })

export const nullableOptionSchema = z.object({
  label: z.custom<string | JSX.Element>(),
  value: z.string().nullable()
}, { message: 'Campo obrigatório' })